module.exports = __webpack_public_path__ + "static/media/markus-winkler-cover.1c8f8e08.svg";